import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';
import ArrowRight from 'components/ui/icon/ArrowRight';
import {Link} from 'react-router-dom';

import './Marketplace.scss';

const Marketplace = () => {
  return (
    <section className="marketplace">
      <Container extraClassName="marketplace__wrapper">
        <Title
          extraClassName="marketplace__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          Руки&nbsp;&mdash; маркетплейс домашнего&nbsp;ремонта
        </Title>

        <p className="marketplace__subscript">
          Вы&nbsp;размещаете заказ, мы&nbsp;передаём его зарегистрированным
          мастерам.
        </p>

        <div className="marketplace__list">
          <div className="marketplace__item marketplace__item-specialists">
            <Title
              extraClassName="marketplace__item-title"
              level={TitleLevel.H3}
              size={TitleSize.H3}
            >
              Наши мастера
            </Title>

            <p className="marketplace__item-description">
              Мы&nbsp;отбираем мастеров, способных хорошо выполнить ремонт.
              Отбор мастеров наша ключевая компетенция.
            </p>

            <div className="marketplace__item_bottom">
              <Link to="/specialists" className="marketplace__item-button">
                О мастерах <ArrowRight color="#65E7E6" />
              </Link>
            </div>
          </div>

          <div className="marketplace__item marketplace__item-warranty">
            <Title
              extraClassName="marketplace__item-title"
              level={TitleLevel.H3}
              size={TitleSize.H3}
            >
              Наши гарантии
            </Title>

            <p className="marketplace__item-description">
              Сервис несёт материальную ответственность за&nbsp;качество ремонта
              и&nbsp;материалы клиента.
            </p>

            <div className="marketplace__item_bottom">
              <span className="marketplace__item-extra">
                До&nbsp;250&nbsp;000&nbsp;₽
              </span>

              <Link to="/warranty" className="marketplace__item-button">
                О&nbsp;гарантии <ArrowRight color="#00F" />
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Marketplace;
